/**
 * 原型 v0.22 的**演示数据**，机械抽自 `web/prototype/v0.22/index.html`（C-159 A.2）。
 *
 * ## 这份文件里没有一个真数字
 *
 * 原型底部自述：「结构取自真实交付项目，企业名为演示别名，**全部数值为演示数据**」。
 * 故凡渲染本文件里的值，界面上**必须带 SBX 角标**（T.2：零格冒充真数据）。
 *
 * ## 不手改
 *
 * 由 `ops/prototype/extract-demo.py` 生成。原型改了重跑，
 * **手改一次它与原型的对应关系就断了**，而「与原型一致」是 T.1 的判据。
 *
 * ## 已接真数据的部分不用这里的值
 *
 * 树／部门／岗位／卡数／首屏五数走线上真数据（那几条链路已通）。
 * 本文件只补**还没有数据源**的那些格子：热力图趋势、达成率、运营秘书、运行日志、
 * 卡的运行状态灯——它们要 `taskrun` / `daily_commitment`，而那是第二步的事。
 */

/* ═══ 以下由 extract-demo.py 生成，手改会被下次重跑覆盖 ═══ */

export const ENT = {name:"铸远能源装备",pct:86,pc:"a"} as const;

export const ORG = [
 {id:"dE1",name:"企业运营部",cnt:6,pct:88,pc:"g",sys:true,pos:[
   {id:"pE1",name:"企业运营岗",pct:88,pc:"g",sys:true,hc:31,ai:.45,tr:[24,28,32,36,39,42,44,45],atcs:["ge1","ge2"]}
 ]},
 {id:"dE2",name:"企业建设部",cnt:4,pct:85,pc:"a",sys:true,build:true,pos:[
   {id:"pE2",name:"企业建设岗",pct:85,pc:"a",sys:true,hc:6,ai:.40,tr:[20,24,27,30,33,36,38,40],atcs:["gb1"]}
 ]},
 {id:"d1",name:"热加工车间",cnt:17,pct:84,pc:"a",pos:[
   {id:"pD1",name:"热加工车间部门岗",pct:84,pc:"a",sys:true,hc:4,ai:0.5,tr:[22,26,30,34,38,42,46,50],atcs:["gd1"]},
   {id:"p1",name:"冶炼工艺岗",pct:82,pc:"a",hc:3,ai:.62,tr:[38,44,48,50,55,58,60,62],atcs:["h1","h2","h4","h5"]},
   {id:"p2",name:"热加工调度岗",pct:91,pc:"g",hc:1,ai:.78,tr:[52,58,62,66,70,73,76,78],atcs:["h3","h6"]}
 ]},
 {id:"d2",name:"冷加工车间",cnt:22,pct:88,pc:"g",pos:[
   {id:"p3",name:"冷加工工艺岗",pct:88,pc:"g",hc:5,ai:.55,tr:[30,36,40,44,47,50,53,55],atcs:["c1"]}
 ]},
 {id:"d3",name:"理化检测部",cnt:14,pct:79,pc:"a",pos:[
   {id:"pD3",name:"理化检测部部门岗",pct:79,pc:"a",sys:true,hc:5,ai:0.45,tr:[22,26,30,34,38,42,46,45],atcs:["gd3"]},
   {id:"p4",name:"熔炼化学检验岗",pct:74,pc:"a",hc:4,ai:.48,tr:[22,28,32,36,40,43,46,48],atcs:["t1","t2"]},
   {id:"p5",name:"理化主任岗",pct:90,pc:"g",hc:1,ai:.70,tr:[45,50,55,58,62,65,68,70],atcs:["t3","t4"]}
 ]},
 {id:"d4",name:"检验检测部",cnt:6,pct:93,pc:"g",pos:[
   {id:"p6",name:"金工扫描岗",pct:93,pc:"g",hc:2,ai:.58,tr:[34,38,42,46,50,53,56,58],atcs:["j1"]}
 ]},
 {id:"d5",name:"库存管理部",cnt:18,pct:87,pc:"g",pos:[
   {id:"p7",name:"理化库存岗",pct:87,pc:"g",hc:4,ai:.60,tr:[36,40,45,49,52,55,58,60],atcs:["k1"]}
 ]},
 {id:"d6",name:"销售部",cnt:5,pct:95,pc:"g",pos:[
   {id:"pD6",name:"销售部部门岗",pct:95,pc:"g",sys:true,hc:3,ai:0.55,tr:[22,26,30,34,38,42,46,55],atcs:["gd6"]},
   {id:"p8",name:"销售文秘岗",pct:96,pc:"g",hc:2,ai:.74,tr:[48,54,58,62,66,69,72,74],atcs:["s1","s2"]},
   {id:"p9",name:"销售经理岗",pct:94,pc:"g",hc:1,ai:.35,tr:[18,21,24,26,29,31,33,35],atcs:["s3"]}
 ]},
 {id:"d7",name:"财务管理部",cnt:5,pct:90,pc:"g",pos:[
   {id:"p10",name:"财务主任岗",pct:90,pc:"g",hc:1,ai:.52,tr:[28,33,37,41,44,47,50,52],atcs:["f1"]}
 ]},
 {id:"d8",name:"领导层",cnt:8,pct:72,pc:"a",pos:[
   {id:"p11",name:"生产副总岗",pct:72,pc:"a",hc:1,ai:.30,tr:[15,18,20,22,25,27,28,30],atcs:["l1"]}
 ]},
 {id:"d0a",name:"现场交付部",cnt:10,pct:90,pc:"g",build:true,pos:[
   {id:"pD0a",name:"现场交付部部门岗",pct:90,pc:"g",sys:true,hc:3,ai:0.42,tr:[20,24,28,32,36,40,44,42],atcs:["gd0a"]},
   {id:"pf",name:"FDE 岗",pct:92,pc:"g",hc:2,ai:.45,tr:[25,30,33,36,39,41,43,45],atcs:["fd1","fd2","fd3","fd4","fd5"]},
   {id:"pp",name:"PO 岗（项目管理者）",pct:88,pc:"g",hc:1,ai:.40,tr:[22,26,29,32,34,36,38,40],atcs:["po1","po2","po3","po4","po5"]}
 ]},
 {id:"d0b",name:"平台建设部",cnt:11,pct:88,pc:"g",build:true,pos:[
   {id:"pD0b",name:"平台建设部部门岗",pct:88,pc:"g",sys:true,hc:3,ai:0.48,tr:[20,24,28,32,36,40,44,48],atcs:["gd0b"]},
   {id:"pd",name:"数据运营岗",pct:90,pc:"g",hc:2,ai:.66,tr:[40,46,50,54,58,61,64,66],atcs:["da1","da2","da3","da4","da5","da6"]},
   {id:"ps",name:"系统建设岗",pct:85,pc:"a",hc:1,ai:.55,tr:[32,37,41,45,48,51,53,55],atcs:["sy1","sy2","sy3","sy4","sy5"]}
 ]}
] as const;

export const ATC = {
/* 共享 ATC：挂在系统岗位下表达共享范围——不再挂部门或企业下 */
 ge1:{code:"ATC-ENT-001",name:"全员填报周工作纪要",cls:"op",run:"idle",
  desc:"企业全员通用卡：每周填报本周工作纪要，由岗位智能体归集成部门与企业周报。挂企业运营岗下，全企业运营职能可用。",
  dep:"dE1",pos:"pE1",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每周五 16:00",eff:"2026-05 起",
  executor:"人工填报 + 岗位智能体归集",
  what:"全员按模板填报周工作纪要，智能体归集成部门与企业周报。",how:"模板字段必填；缺报按未提交计。",
  act:["下发填报提醒","归集填报内容","生成部门与企业周报"],
  test:"应报人数与实报人数比对无遗漏；周报字段完整。",
  bp:null,runs:[["2026-08-08","hybrid","success","2 h","tr-E1…1A"]],
  stat:{n30:4,ok:"98%",avg:"2 h",health:"g"},attr:{meeting:2,email:6,im:31,doc:12},dom:"dc-ent-01",
  src:[["企业办公群（原生·IM）","granted"]],secret:"未设定",tables:[]},
 ge2:{code:"ATC-ENT-002",name:"全员核对月度考勤异常",cls:"op",run:"idle",
  desc:"企业全员通用卡：核对本人月度考勤异常项并确认。挂企业运营岗下。",
  dep:"dE1",pos:"pE1",det:"deterministic",mat:1,status:"active",hotl:false,trig:"schedule · 每月 1 日",eff:"2026-06 起",
  executor:"人工确认 + 岗位智能体核验",
  what:"核对考勤异常项并逐项确认或申诉。",how:"以考勤系统记录为准。",
  act:["生成个人异常清单","收集确认与申诉","汇总人事"],
  test:"全部异常项有处置结论。",
  bp:null,runs:[],stat:{n30:1,ok:"100%",avg:"20 min",health:"g"},
  attr:{meeting:0,email:8,im:14,doc:5},dom:"dc-ent-01",src:[["考勤系统桥接（bridge）","granted"]],secret:"未设定",tables:[]},
 gb1:{code:"ATC-BLD-001",name:"交付人员登记项目工时",cls:"bld",run:"run",
  desc:"建设职能通用卡：交付人员按项目登记工时与产出。挂企业建设岗下，全部建设岗位可用。",
  dep:"dE2",pos:"pE2",det:"deterministic",mat:3,status:"active",hotl:false,trig:"schedule · 每业务日",eff:"2026-03 起",
  executor:"FDE 工程师 / PO / 数据运营岗 / 系统建设岗 + 智能体归集",
  what:"按项目与 ATC 登记当日工时与产出，供交付成本核算。",how:"工时归到具体建设卡；无对应卡的计入待立卡区。",
  act:["下发登记提醒","归集工时","按项目汇总"],
  test:"登记人数与在岗人数一致；工时全部有项目归属。",
  bp:{ref:"BP-CAP-BLD-010",ver:"v2.0",up:"2026-07-01"},
  runs:[["2026-08-11","hybrid","success","10 min","tr-B1…3C"]],
  stat:{n30:22,ok:"96%",avg:"10 min",health:"g"},attr:{meeting:1,email:2,im:18,doc:6},dom:"dc-bld-01",
  src:[["交付群（原生·IM）","granted"]],secret:"未设定",tables:[]},
 gd1:{code:"ATC-HOT-020",name:"车间全员确认班前安全交底",cls:"op",run:"idle",
  desc:"部门内通用卡：本车间全员班前安全交底确认。挂热加工车间部门岗下，车间内所有岗位可用。",
  dep:"d1",pos:"pD1",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每班次",eff:"2026-04 起",
  executor:"人工确认 + 岗位智能体核验",
  what:"班前安全交底逐人确认。",how:"未确认者不得上岗，升级班长。",
  act:["下发交底内容","收集确认","未确认升级"],test:"当班全员有确认记录。",
  bp:null,runs:[["2026-08-11","hub","success","5 min","tr-D1…2B"]],
  stat:{n30:26,ok:"99%",avg:"5 min",health:"g"},attr:{meeting:1,email:0,im:22,doc:4},dom:"dc-hot-01",
  src:[["车间群（原生·IM）","granted"]],secret:"未设定",tables:[]},
 gd3:{code:"ATC-TES-020",name:"检测部全员确认仪器校准状态",cls:"op",run:"idle",
  desc:"部门内通用卡：使用前确认所用仪器在校准有效期内。挂理化检测部部门岗下。",
  dep:"d3",pos:"pD3",det:"deterministic",mat:2,status:"active",hotl:false,trig:"event · 每次检测前",eff:"2026-05 起",
  executor:"人工确认 + 岗位智能体核验",
  what:"检测前确认仪器校准有效。",how:"超期仪器禁用并报修。",
  act:["查校准台账","确认或拦截","超期报修"],test:"超期仪器零使用记录。",
  bp:null,runs:[],stat:{n30:31,ok:"100%",avg:"2 min",health:"g"},
  attr:{meeting:0,email:1,im:9,doc:7},dom:"dc-tes-01",src:[["校准台账（原生·文档）","granted"]],secret:"未设定",tables:[]},
 gd6:{code:"ATC-SAL-020",name:"销售部全员更新客户拜访记录",cls:"op",run:"idle",
  desc:"部门内通用卡：拜访后当日更新记录。挂销售部部门岗下。",
  dep:"d6",pos:"pD6",det:"deterministic",mat:2,status:"active",hotl:false,trig:"event · 拜访后",eff:"2026-04 起",
  executor:"人工填报 + 岗位智能体归集",
  what:"拜访后更新客户记录与后续动作。",how:"当日未更新次日提醒。",
  act:["提醒填报","归集记录","生成跟进清单"],test:"拜访与记录一一对应。",
  bp:null,runs:[],stat:{n30:18,ok:"94%",avg:"8 min",health:"g"},
  attr:{meeting:3,email:12,im:16,doc:5},dom:"dc-sal-01",src:[["销售群（原生·IM）","granted"]],secret:"未设定",tables:[]},
 gd0a:{code:"ATC-FDE-020",name:"交付全员提交每日日报",cls:"bld",run:"idle",
  desc:"部门内通用卡：现场交付部全员按  提交日报至代码库。挂现场交付部部门岗下。",
  dep:"d0a",pos:"pD0a",det:"deterministic",mat:3,status:"active",hotl:false,trig:"schedule · 每业务日下班前",eff:"2026-08 起",
  executor:"人工提交 + 设计者 review",
  what:"按模板提交当日改动、问题与建议、明日计划、待确认事项。",
  how:"引用条款须给编号；日报与代码变更同批提交。",
  act:["撰写日报","提交至 docs/journal/daily/","接收 review 反馈"],
  test:"每业务日有日报；条款引用带编号。",
  bp:{ref:"BP-CAP-BLD-011",ver:"v1.0",up:"2026-08-12"},runs:[],
  stat:{n30:1,ok:"100%",avg:"20 min",health:"g"},attr:{meeting:0,email:0,im:4,doc:3},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 gd0b:{code:"ATC-SYS-020",name:"平台全员登记环境变更",cls:"bld",run:"idle",
  desc:"部门内通用卡：任何环境或配置变更须登记。挂平台建设部部门岗下。",
  dep:"d0b",pos:"pD0b",det:"deterministic",mat:2,status:"active",hotl:false,trig:"event · 变更后",eff:"2026-06 起",
  executor:"人工登记 + 智能体核验",
  what:"登记变更内容、原因、影响范围与回滚方式。",how:"未登记变更视为违规。",
  act:["登记变更","核验影响","归档"],test:"变更与登记一一对应；每条有回滚方式。",
  bp:null,runs:[],stat:{n30:6,ok:"100%",avg:"12 min",health:"g"},
  attr:{meeting:0,email:2,im:7,doc:4},dom:"dc-bld-01",src:[],secret:"未设定",tables:[]},
 h1:{code:"ATC-HOT-001",name:"工艺员开具冶炼工艺卡",cls:"op",run:"run",
  desc:"依据冷加工、热加工开卡后的订单剩余投料量，开具冶炼工艺卡并写回生产管理系统。",
  dep:"d1",pos:"p1",det:"deterministic",mat:3,status:"active",hotl:true,
  trig:"event · 销售未投料明细更新后",eff:"2026-03 起",executor:"岗位智能体 + 工艺员确认",
  what:"以销售未投料明细（订单剩余冶炼需求量、物料信息）为输入，开具冶炼工艺卡。边界：仅冶炼工艺卡，电渣与锻造工艺另卡处理。触发：销售未投料明细更新后。",
  how:"以钢种＋执行标准为索引，从成分要求标准值、内控值、目标值三张配置表取值填充；订单信息（用户、合同号、交货期、成品规格）以销售订单明细为准；手工录入的内控/目标值须回写值库。",
  act:["经数据连接读取销售订单明细与销售未投料明细","按销售订单明细号自动填充订单信息","按钢种＋执行标准从三张配置表选择填充 12 项元素（C·Si·Mn·P·S·Ni·Cr·Mo·Cu·Ti·Al·Fe）含量范围","写入冶炼生产工艺单与工艺卡统计报表","提交工艺主管审批（hotl）"],
  test:"工艺卡必填字段完整率 100%；12 项元素含量范围与所选标准值零偏差；工艺单号唯一（流水号＋日期组合）；写回生产管理系统可查。任一不满足判 failed。",
  bp:{ref:"BP-MFG-HOT-001",ver:"v2.0",up:"2026-07-18"},
  runs:[["2026-08-10","hub","success","6 min","tr-H1…9A"],["2026-08-10","hub","awaiting_approval","—","tr-H1…9B"],["2026-08-08","hybrid","success","14 min","tr-H1…7C"],["2026-08-05","hub","failed（判据②偏差）","5 min","tr-H1…3D"]],
  owners:["张工（工艺员）","李工（工艺员）","王工（工艺主管）"],
  ownRule:"岗位内 3 人可负责；部门级可调用——谁调用谁负责",
  userRefs:["冶炼工艺岗全员（3 人）","热加工调度岗（可调用）"],
  evals:["王工（工艺主管）","质量部 · 陈工"],
  ppl:[["张工","责任人","热加工车间 · 冶炼工艺岗","2026-03-01",true],
       ["李工","责任人","热加工车间 · 冶炼工艺岗","2026-03-01",true],
       ["王工（工艺主管）","责任人","热加工车间","2026-03-01",true],
       ["冶炼工艺岗全员（3 人）","使用者","热加工车间 · 冶炼工艺岗","2026-03-01",true],
       ["热加工调度岗（可调用）","使用者","热加工车间","2026-05-10",true],
       ["王工（工艺主管）","评价者","热加工车间","2026-03-01",true],
       ["赵工","使用者","热加工车间 · 冶炼工艺岗","2026-04-15",false],
       ["陈工","评价者","质量部","2026-06-01",true]],
  yearN:862,users:3,quality:"98%",avgTrend:[12,11,10,9,9,8,7,7],verN:3,
  agent:"WA-01 · 开卡工作智能体",
  sop:[
   ["1","接单","每周日 20:00 取销售未投料明细；核对订单剩余冶炼需求量与物料信息是否完整","缺项则挂起并通知计划岗，不带缺项开卡"],
   ["2","定标","按钢种＋执行标准检索三张配置表（标准值 c007／内控值 c008／目标值 c009）","标准缺失或多版本冲突时停，交工艺主管裁定"],
   ["3","填卡","自动填充订单信息与 12 项元素含量范围（C·Si·Mn·P·S·Ni·Cr·Mo·Cu·Ti·Al·Fe）","手工录入的内控／目标值须同步回写值库"],
   ["4","编号","按流水号＋日期生成工艺单号","单号唯一，重号即失败"],
   ["5","自检","逐项比对 TEST 判据：必填完整率、元素范围、单号唯一","任一不满足判 failed，不提交"],
   ["6","送审","提交工艺主管审批（hotl_gate）","未批不得置 success"],
   ["7","写回","审批通过后写入生产管理系统与工艺卡统计报表","写回失败保留草案并告警"]],
  skills:[
   ["表格结构化解析","从销售明细与配置表提取结构化字段","内置"],
   ["标准检索与匹配","按钢种＋执行标准双键检索三表","内置"],
   ["数值范围校验","12 项元素含量范围比对与超差判定","内置"],
   ["单号生成","流水号＋日期组合，唯一性校验","内置"],
   ["系统写回","经数据链接写入生产管理系统","经 bridge 授权"]],
  benches:[
   ["生产管理系统 · 工艺单模块","写入与查询工艺单","https://mes.example.internal/craft/order","bridge · granted"],
   ["销售订单明细台账","读取未投料明细","https://mes.example.internal/sales/pending","bridge · granted"],
   ["工艺卡统计报表","结果复核与导出","https://mes.example.internal/report/craft","只读"]],
  ledger:[
   ["08-10 08:12","岗位智能体","销售未投料明细更新","张工","6 min","冶炼工艺单 GY-0810-003","success","tr-H1…9A","达标 · 判据 4/4 通过"],
   ["08-10 15:40","岗位智能体","插单后明细复更","张工","—","（草案）待审批","awaiting_approval","tr-H1…9B","待审后评"],
   ["08-08 09:05","李工 + 智能体","新钢种首单（hybrid）","李工","14 min","冶炼工艺单 GY-0808-001","success","tr-H1…7C","达标 · 新钢种首单，人工复核通过"],
   ["08-05 10:22","岗位智能体","明细更新","王工","5 min","（退回）","failed","tr-H1…3D","偏差 · 判据②元素范围超差"],
   ["08-03 08:10","岗位智能体","明细更新","张工","6 min","冶炼工艺单 GY-0803-002","success","tr-H1…1E","达标 · 判据 4/4 通过"],
   ["08-01 08:09","岗位智能体","明细更新","张工","7 min","冶炼工艺单 GY-0801-004","success","tr-H1…5F","达标 · 判据 4/4 通过"],
   ["07-29 08:11","岗位智能体","明细更新","张工","7 min","冶炼工艺单 GY-0729-001","success","tr-H1…8G","达标 · 判据 4/4 通过"],
   ["07-27 08:08","岗位智能体","明细更新","李工","8 min","冶炼工艺单 GY-0727-002","success","tr-H1…2H","达标 · 判据 4/4 通过"],
   ["07-24 08:14","岗位智能体","明细更新","张工","8 min","冶炼工艺单 GY-0724-003","success","tr-H1…6J","达标 · 判据 4/4 通过"],
   ["07-22 08:10","岗位智能体","明细更新","张工","9 min","冶炼工艺单 GY-0722-001","success","tr-H1…4K","达标 · 判据 4/4 通过"]],
  stat:{n30:41,ok:"92%",avg:"7 min",health:"g"},
  attr:{meeting:6,email:12,im:38,doc:22},dom:"dc-hot-01",
  src:[["生产管理系统数据连接","granted"],["工艺周会（原生·会议）","granted"]],
  secret:"HOW 段 protection_level = masked",
  tables:["成分要求标准值配置表 c007","成分要求内控值配置表 c008","成分要求目标值配置表 c009","冶炼生产工艺单 p001","成分要求表 p002"]},
 h2:{code:"ATC-HOT-002",name:"工艺员开具电渣工艺卡",cls:"op",run:"idle",desc:"电渣重熔工艺卡开具与写回。",dep:"d1",pos:"p1",det:"deterministic",mat:2,status:"active",hotl:true,trig:"event · 冶炼工艺卡下达后",eff:"2026-04 起",executor:"岗位智能体 + 工艺员确认",
  what:"承接冶炼工艺卡，生成电渣重熔工艺卡。",how:"渣系与锭型按工艺规程配置表取值。",act:["读取冶炼工艺卡","按锭型取渣系配置","写回工艺单"],test:"必填字段完整率 100%；渣系配置与规程零偏差。",bp:{ref:"BP-MFG-HOT-002",ver:"v1.3",up:"2026-06-20"},runs:[["2026-08-09","hub","success","4 min","tr-H2…2E"]],stat:{n30:18,ok:"94%",avg:"5 min",health:"g"},attr:{meeting:2,email:4,im:15,doc:8},dom:"dc-hot-01",src:[["生产管理系统数据连接","granted"]],secret:"未设定",tables:[]},
 h3:{code:"ATC-HOT-009",name:"调度员统计热加工投料进度",cls:"op",run:"run",desc:"按日汇总热加工投料进度并生成偏差清单。",dep:"d1",pos:"p2",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每业务日 16:30",eff:"2026-05 起",executor:"岗位智能体",
  what:"汇总当日热加工各工序投料量与计划对比。",how:"以生产管理系统投料记录为准。",act:["读取投料记录","比对计划","生成偏差清单"],test:"当日全部工序有统计；偏差清单与源数据抽查零误差。",bp:null,runs:[["2026-08-10","hub","success","3 min","tr-H9…1F"]],stat:{n30:26,ok:"96%",avg:"3 min",health:"g"},attr:{meeting:1,email:2,im:9,doc:3},dom:"dc-hot-01",src:[["生产管理系统数据连接","granted"]],secret:"未设定",tables:[]},
 h4:{code:"ATC-HOT-004",name:"工艺员核对图纸技术交底记录",cls:"op",run:"idle",
  desc:"新图纸下发后人工核对技术交底记录并留档。尚未 AI 化——全量映射中的人工执行卡，AI 化候选。",
  dep:"d1",pos:"p1",det:"deterministic",mat:0,status:"active",hotl:false,trig:"event · 新图纸下发后",eff:"2026-03 起",
  executor:"人工（工艺员）",
  what:"逐张核对新下发图纸与技术交底记录的一致性并留档。",how:"以最新版图纸为准；差异登记升级。",
  act:["取图纸与交底记录","逐项核对","差异登记留档"],test:"核对记录留档；差异零漏报（抽查）。",
  bp:null,runs:[["2026-08-08","human","success","42 min","tr-H4…1Q"]],
  stat:{n30:9,ok:"100%",avg:"40 min",health:"g"},attr:{meeting:1,email:2,im:6,doc:11},dom:"dc-hot-01",
  src:[["工艺群（原生·IM）","granted"]],secret:"未设定",tables:[]},
 h5:{code:"ATC-HOT-005",name:"工艺员整理班组交接记录",cls:"op",run:"idle",
  desc:"每班次人工整理交接记录并归档。人工执行卡，AI 化候选（OCR＋结构化提取可替代）。",
  dep:"d1",pos:"p1",det:"deterministic",mat:0,status:"active",hotl:false,trig:"schedule · 每班次",eff:"2026-03 起",
  executor:"人工（工艺员）",
  what:"整理并归档班组交接记录。",how:"按交接模板逐项填写。",
  act:["收集手写记录","按模板整理","归档"],test:"每班次有归档记录；要素齐全。",
  bp:null,runs:[["2026-08-10","human","success","24 min","tr-H5…2R"]],
  stat:{n30:26,ok:"96%",avg:"25 min",health:"g"},attr:{meeting:0,email:0,im:12,doc:18},dom:"dc-hot-01",
  src:[["交接本扫描（原生·文档）","granted"]],secret:"未设定",tables:[]},
 h6:{code:"ATC-HOT-010",name:"调度员汇总设备停机台账",cls:"op",run:"idle",
  desc:"人工汇总各机台停机原因与时长。人工执行卡，AI 化候选（对接设备系统后可自动生成）。",
  dep:"d1",pos:"p2",det:"deterministic",mat:0,status:"active",hotl:false,trig:"schedule · 每业务日",eff:"2026-04 起",
  executor:"人工（调度员）",
  what:"按日汇总设备停机台账。",how:"以机台记录本为准。",
  act:["收集机台记录","汇总台账","归档"],test:"当日全部机台有记录；台账与原始记录一致。",
  bp:null,runs:[["2026-08-10","human","success","28 min","tr-H6…3S"]],
  stat:{n30:22,ok:"95%",avg:"30 min",health:"g"},attr:{meeting:0,email:1,im:8,doc:9},dom:"dc-hot-01",
  src:[["机台记录扫描（原生·文档）","granted"]],secret:"未设定",tables:[]},
 c1:{code:"ATC-COL-001",name:"工艺员开具冷加工工艺卡",cls:"op",run:"idle",desc:"冷加工工艺卡开具（演示样卡，本部门共 22 张）。",dep:"d2",pos:"p3",det:"deterministic",mat:2,status:"active",hotl:true,trig:"event",eff:"2026-04 起",executor:"岗位智能体 + 工艺员确认",
  what:"依据订单需求开具冷加工工艺卡。",how:"按产品规格与工序路线配置。",act:["读取订单","填充工序路线","写回工艺单"],test:"必填字段完整率 100%。",bp:null,runs:[],stat:{n30:33,ok:"91%",avg:"6 min",health:"g"},attr:{meeting:2,email:3,im:11,doc:6},dom:"dc-col-01",src:[["生产管理系统数据连接","granted"]],secret:"未设定",tables:[]},
 t1:{code:"ATC-TES-002",name:"化学检验员录入熔炼化学成分",cls:"op",run:"await",desc:"熔炼化学成分由纸质抄取转为系统录入。",dep:"d3",pos:"p4",det:"deterministic",mat:1,status:"active",hotl:true,trig:"event · 检验完成后",eff:"2026-06 起",executor:"人工录入 + 岗位智能体核验",
  what:"将熔炼化学检验结果录入系统并核验范围。",how:"12 项元素与标准范围逐项比对。",act:["录入成分数据","范围核验","超差标记"],test:"录入值与原始记录抽查零误差；超差项 100% 标记。",bp:null,runs:[["2026-08-10","human","awaiting_approval","—","tr-T2…4G"]],stat:{n30:22,ok:"86%",avg:"9 min",health:"a"},attr:{meeting:1,email:2,im:14,doc:19},dom:"dc-tes-01",src:[["理化检验系统桥接（bridge）","granted · 退出计划 2026-11"]],secret:"未设定",tables:[]},
 t2:{code:"ATC-TES-009",name:"检验员核验 OCR 识别成分数据",cls:"op",run:"fail",desc:"OCR 自动识别熔炼化学成分并人工核验。",dep:"d3",pos:"p4",det:"deterministic",mat:1,status:"active",hotl:true,trig:"event · 报告单扫描后",eff:"2026-07 起",executor:"岗位智能体 + 检验员核验",
  what:"OCR 解析检验报告单成分数据，人工核验后入库。",how:"识别置信度低于阈值转人工。",act:["OCR 解析","置信度分流","人工核验入库"],test:"入库值与报告单抽查零误差。",bp:null,runs:[["2026-08-10","hub","failed（解析异常）","2 min","tr-T9…6H"]],stat:{n30:19,ok:"79%",avg:"4 min",health:"r"},attr:{meeting:0,email:1,im:8,doc:24},dom:"dc-tes-01",src:[["扫描件目录（原生·文档）","granted"]],secret:"未设定",tables:[]},
 t3:{code:"ATC-TES-010",name:"理化主任统计试样加工进度",cls:"op",run:"idle",desc:"试样加工完成情况与合格性状态统计。",dep:"d3",pos:"p5",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每业务日 17:00",eff:"2026-06 起",executor:"岗位智能体",
  what:"按理化委托单汇总试验完成情况与合格性。",how:"以委托单状态为准。",act:["读取委托单","汇总状态","生成统计"],test:"全部委托单有状态；统计与明细一致。",bp:null,runs:[["2026-08-10","hub","success","3 min","tr-T10…2J"]],stat:{n30:25,ok:"96%",avg:"3 min",health:"g"},attr:{meeting:2,email:3,im:6,doc:11},dom:"dc-tes-01",src:[["理化检验系统桥接（bridge）","granted · 退出计划 2026-11"]],secret:"未设定",tables:[]},
 t4:{code:"ATC-TES-013",name:"理化主任统计试验项目进度",cls:"op",run:"idle",desc:"理化试验项目进度统计。",dep:"d3",pos:"p5",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每周五",eff:"2026-06 起",executor:"岗位智能体",
  what:"按周汇总理化试验项目进度。",how:"以试验记录为准。",act:["读取试验记录","汇总进度"],test:"全部项目有进度值。",bp:null,runs:[],stat:{n30:4,ok:"100%",avg:"2 min",health:"g"},attr:{meeting:1,email:1,im:3,doc:5},dom:"dc-tes-01",src:[["理化检验系统桥接（bridge）","granted"]],secret:"未设定",tables:[]},
 j1:{code:"ATC-TES-007",name:"扫描员登记试样金工扫描",cls:"op",run:"idle",desc:"按试样加工委托单登记金工扫描记录。",dep:"d4",pos:"p6",det:"deterministic",mat:1,status:"active",hotl:false,trig:"event",eff:"2026-07 起",executor:"人工 + 岗位智能体核验",
  what:"按委托单登记扫描记录。",how:"委托单号唯一关联。",act:["读取委托单","登记扫描记录"],test:"记录与委托单一一对应。",bp:null,runs:[],stat:{n30:31,ok:"93%",avg:"2 min",health:"g"},attr:{meeting:0,email:0,im:5,doc:9},dom:"dc-tes-01",src:[["理化检验系统桥接（bridge）","granted"]],secret:"未设定",tables:[]},
 k1:{code:"ATC-INV-001",name:"库存员登记试样残余样二维码",cls:"op",run:"idle",desc:"残样与余样二维码登记及货架管理（演示样卡，本部门共 18 张）。",dep:"d5",pos:"p7",det:"deterministic",mat:1,status:"active",hotl:false,trig:"event",eff:"2026-07 起",executor:"人工 + 岗位智能体核验",
  what:"为残样余样生成并登记二维码，关联货架位。",how:"样品编号唯一。",act:["生成二维码","登记货架位"],test:"样品与二维码一一对应；货架位可查。",bp:null,runs:[],stat:{n30:28,ok:"89%",avg:"3 min",health:"g"},attr:{meeting:0,email:1,im:7,doc:4},dom:"dc-inv-01",src:[["库存系统桥接（bridge）","granted"]],secret:"未设定",tables:[]},
 s1:{code:"ATC-SAL-001",name:"销售文秘录入销售订单并同步",cls:"op",run:"run",desc:"销售订单明细录入并同步至财务系统。",dep:"d6",pos:"p8",det:"deterministic",mat:3,status:"active",hotl:false,trig:"event · 合同签订后",eff:"2026-02 起",executor:"人工录入 + 岗位智能体同步",
  what:"录入销售订单明细并同步下游系统。",how:"以合同为唯一依据；同步字段映射按接口规范。",act:["录入订单明细","字段校验","同步下游系统"],test:"同步后两系统关键字段零偏差（抽查 20 条）。",bp:{ref:"BP-MFG-SAL-001",ver:"v3.1",up:"2026-08-01"},runs:[["2026-08-10","hybrid","success","5 min","tr-S1…8K"]],stat:{n30:37,ok:"97%",avg:"5 min",health:"g"},attr:{meeting:3,email:21,im:12,doc:7},dom:"dc-sal-01",src:[["销售邮箱（原生·邮件）","granted"],["财务系统桥接（bridge）","granted"]],secret:"未设定",tables:[]},
 s2:{code:"ATC-SAL-003",name:"销售文秘维护物料单价数据",cls:"op",run:"idle",desc:"所售物料单价数据维护。",dep:"d6",pos:"p8",det:"deterministic",mat:2,status:"active",hotl:true,trig:"manual",eff:"2026-03 起",executor:"人工 + 主管审批",
  what:"维护物料单价库。",how:"调价须留审批痕迹。",act:["提交调价","主管审批","生效"],test:"每次调价有审批记录。",bp:null,runs:[],stat:{n30:6,ok:"100%",avg:"—",health:"g"},attr:{meeting:1,email:5,im:2,doc:3},dom:"dc-sal-01",src:[["销售邮箱（原生·邮件）","granted"]],secret:"未设定",tables:[]},
 s3:{code:"ATC-SAL-005",name:"销售经理审核报价单与合同",cls:"op",run:"await",desc:"报价单与合同审核流程。",dep:"d6",pos:"p9",det:"deterministic",mat:2,status:"active",hotl:true,trig:"event · 报价单提交后",eff:"2026-03 起",executor:"岗位智能体预审 + 销售经理批准",
  what:"预审报价单与合同要件，经理批准。",how:"要件清单逐项核对；价格权限分级。",act:["要件预审","超权限标记","经理批准"],test:"要件缺失 100% 拦截；审批记录完整。",bp:null,runs:[["2026-08-10","hub","awaiting_approval","—","tr-S5…3L"]],stat:{n30:14,ok:"93%",avg:"11 min",health:"g"},attr:{meeting:2,email:16,im:4,doc:12},dom:"dc-sal-01",src:[["销售邮箱（原生·邮件）","granted"]],secret:"未设定",tables:[]},
 f1:{code:"ATC-FIN-005",name:"财务主任复核成品发货信息",cls:"op",run:"idle",desc:"对已审核发货信息二次复核并存档。",dep:"d7",pos:"p10",det:"deterministic",mat:2,status:"active",hotl:true,trig:"event · 发货单审核完毕后",eff:"2026-05 起",executor:"岗位智能体预核 + 财务主任把关",
  what:"复核发货单、收货信息、数量规格的准确性、合规性与完整性，形成审核记录存档。",how:"与销售订单明细逐项比对。",act:["读取发货单","逐项比对","记录存档"],test:"复核记录 100% 存档；比对偏差零漏报。",bp:null,runs:[],stat:{n30:12,ok:"100%",avg:"8 min",health:"g"},attr:{meeting:1,email:9,im:2,doc:8},dom:"dc-fin-01",src:[["财务系统桥接（bridge）","granted"]],secret:"数据保密：结果仅财务域可见（V-1 至 V-6）",tables:[]},
 l1:{code:"ATC-LEA-001",name:"生产副总查看投料齐套日报",cls:"op",run:"idle",desc:"领导层日报查看（演示样卡，本层共 8 张）。",dep:"d8",pos:"p11",det:"deterministic",mat:1,status:"active",hotl:false,trig:"schedule · 每业务日 08:00",eff:"2026-06 起",executor:"岗位智能体",
  what:"生成投料与齐套日报供决策。",how:"以各车间统计卡输出为准。",act:["汇总统计","生成日报"],test:"日报字段完整；与源统计一致。",bp:null,runs:[],stat:{n30:22,ok:"72%",avg:"2 min",health:"a"},attr:{meeting:4,email:2,im:1,doc:15},dom:"dc-lea-01",src:[["各车间统计卡输出","granted"]],secret:"未设定",tables:[]},

 /* ===== 建设 ATC：四个建设岗位，挂在「体系建设（交付）」节点下。
    这些卡对应我方交付作业方法的标准动作；客户由此看见知识体系如何积累，将来可自行执行。 ===== */

 /* ---- FDE 岗：进现场构建 ---- */
 fd1:{code:"ATC-FDE-001",name:"FDE 调研岗位任务并产出候选清单",cls:"bld",run:"idle",
  desc:"进场标准动作：调研目标部门各岗位的任务、数据与判据，产出 ATC 候选清单。客户知识体系由此开始积累。",
  dep:"d0a",pos:"pf",det:"deterministic",mat:4,status:"active",hotl:false,trig:"manual · 每部门进场时",eff:"2026-02 起",
  executor:"FDE 工程师 + 客户业务同事",
  what:"访谈目标部门全部岗位，还原每项重复性任务的输入、输出与判据，形成 ATC 候选清单。边界：只调研与登记，不改现有作业。",
  how:"按命名规范（岗位＋动词＋动作）登记；每项任务须能回答四段；无法给出客观 TEST 的记入待定区不立卡。",
  act:["岗位访谈与录音归档","任务清单结构化","四段草拟","候选清单评审"],
  test:"部门全部岗位有访谈记录；候选清单每项含责任岗位与 TEST 草案；评审结论留档。",
  bp:{ref:"BP-CAP-FDE-001",ver:"v5.0",up:"2026-08-01"},
  runs:[["2026-02-12","hybrid","success","5 d","tr-F1…1M"],["2026-04-08","hybrid","success","4 d","tr-F1…5Q"]],
  stat:{n30:0,ok:"100%",avg:"4.5 d",health:"g"},attr:{meeting:9,email:3,im:6,doc:14},dom:"dc-bld-01",
  src:[["调研访谈（原生·会议）","granted"]],secret:"HOW 段 protection_level = remote_only",tables:[]},
 fd2:{code:"ATC-FDE-002",name:"FDE 草拟四段并提交立卡",cls:"bld",run:"run",
  desc:"将评审通过的候选任务写成完整四段，提交 in_review。",
  dep:"d0a",pos:"pf",det:"deterministic",mat:3,status:"active",hotl:false,trig:"event · 候选清单评审通过后",eff:"2026-02 起",
  executor:"FDE 工程师 + 客户业务同事",
  what:"逐项候选任务草拟 WHAT / HOW / ACTION / TEST 并提交评审。",
  how:"TEST 必须客观可判；跨岗位任务先拆分（粒度准则）。",
  act:["四段撰写","责任岗位确认","提交 in_review"],
  test:"提交卡四段齐全；TEST 可独立判定通过或失败。",
  bp:{ref:"BP-CAP-FDE-002",ver:"v2.3",up:"2026-07-22"},runs:[["2026-08-10","hybrid","success","2 h","tr-F2…8R"]],
  stat:{n30:12,ok:"92%",avg:"2 h",health:"g"},attr:{meeting:4,email:2,im:11,doc:9},dom:"dc-bld-01",
  src:[["工作会议（原生·会议）","granted"]],secret:"未设定",tables:[]},
 fd3:{code:"ATC-FDE-003",name:"FDE 验证 TEST 判据于真实历史",cls:"bld",run:"idle",
  desc:"用客户真实历史数据回放候选卡的 TEST 判据，验证可判定性。",
  dep:"d0a",pos:"pf",det:"deterministic",mat:3,status:"active",hotl:false,trig:"event · 立卡提交后",eff:"2026-03 起",
  executor:"FDE 工程师 + 客户业务同事",
  what:"以真实历史场景回放验证每张候选卡的 TEST。",how:"历史样本不少于既定条数；判据不可判定则退回改写。",
  act:["抽取历史样本","判据回放","出具验证结论"],test:"每卡有验证结论；退回项有改写记录。",
  bp:{ref:"BP-CAP-FDE-003",ver:"v1.2",up:"2026-08-05"},runs:[],
  stat:{n30:8,ok:"88%",avg:"3 h",health:"g"},attr:{meeting:2,email:1,im:4,doc:12},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 fd4:{code:"ATC-FDE-004",name:"FDE 组织岗位智能体上岗考核",cls:"bld",run:"idle",
  desc:"以企业真实历史场景为题组织上岗考核。考核不通过，不签发任务卡。",
  dep:"d0a",pos:"pf",det:"deterministic",mat:2,status:"active",hotl:true,trig:"event · ATC 进入 certified 前",eff:"2026-04 起",
  executor:"FDE 工程师 + 客户业务同事 + 岗位负责人",
  what:"以真实历史场景检验岗位智能体是否理解场景、识别问题、给出可执行方案。",
  how:"题目照真实历史出，方有标准答案可对；出现编造一票否决。",
  act:["组卷","考核执行","评分与结论","签发或退回"],
  test:"考核记录完整；通过线达标方可 certified；编造零容忍。",
  bp:{ref:"BP-CAP-FDE-004",ver:"v1.0",up:"2026-08-08"},runs:[],
  stat:{n30:3,ok:"67%",avg:"半天",health:"a"},attr:{meeting:3,email:1,im:2,doc:7},dom:"dc-bld-01",
  src:[],secret:"HOW 段 protection_level = masked",tables:[]},
 fd5:{code:"ATC-FDE-005",name:"FDE 陪跑试运行并登记偏差",cls:"bld",run:"idle",
  desc:"新卡上岗后的陪跑期，逐次登记执行偏差并回流改进。",
  dep:"d0a",pos:"pf",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 陪跑期每业务日",eff:"2026-04 起",
  executor:"FDE 工程师 + 客户业务同事",
  what:"陪跑期内逐次核对新卡执行结果与 TEST。",how:"偏差按类型登记；连续达标出陪跑期。",
  act:["逐次核对","偏差登记","出期评估"],test:"陪跑期每次执行有核对记录；出期有评估结论。",
  bp:null,runs:[["2026-08-08","hybrid","success","1 h","tr-F5…2S"]],
  stat:{n30:16,ok:"94%",avg:"1 h",health:"g"},attr:{meeting:1,email:0,im:8,doc:5},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},

 /* ---- PO 岗（项目管理者） ---- */
 po1:{code:"ATC-PO-001",name:"PO 组织项目启动与治理边界告知",cls:"bld",run:"idle",
  desc:"项目启动标准动作：范围确认、治理边界 G-1 至 G-6 告知与授权签署。",
  dep:"d0a",pos:"pp",det:"deterministic",mat:4,status:"active",hotl:true,trig:"manual · 项目启动时",eff:"2026-02 起",
  executor:"PO + 客户管理层",
  what:"组织启动会，完成建设范围、里程碑与治理边界的告知与书面授权。",
  how:"治理边界逐条告知留痕；授权条款签署后方可开始数据接入。",
  act:["启动会组织","边界告知","授权签署归档"],test:"告知记录与授权文件齐全归档；未授权域零接入。",
  bp:{ref:"BP-CAP-PO-001",ver:"v3.0",up:"2026-07-30"},runs:[["2026-02-05","human","success","1 d","tr-P1…1T"]],
  stat:{n30:0,ok:"100%",avg:"1 d",health:"g"},attr:{meeting:5,email:8,im:2,doc:11},dom:"dc-bld-01",
  src:[["启动会（原生·会议）","granted"]],secret:"未设定",tables:[]},
 po2:{code:"ATC-PO-002",name:"PO 登记里程碑与验收准则",cls:"bld",run:"idle",
  desc:"里程碑计划与验收准则（含知识隔离验收、离线运行验收）登记为项目基线。",
  dep:"d0a",pos:"pp",det:"deterministic",mat:3,status:"active",hotl:false,trig:"event · 启动会后",eff:"2026-02 起",
  executor:"PO",
  what:"登记 M0 至 M6 里程碑、交付物与完成判据。",how:"验收准则照规范条款引用编号，不写大意。",
  act:["里程碑登记","验收准则引用","基线冻结"],test:"每个里程碑有交付物与判据编号；基线版本留档。",
  bp:{ref:"BP-CAP-PO-002",ver:"v2.1",up:"2026-07-12"},runs:[],
  stat:{n30:1,ok:"100%",avg:"2 h",health:"g"},attr:{meeting:2,email:4,im:1,doc:9},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 po3:{code:"ATC-PO-003",name:"PO 维护 ATC 注册表并对齐合同",cls:"bld",run:"run",
  desc:"注册表是合同附件：逐张列明名称、责任岗位与 TEST 判据，防止标的量歧义。",
  dep:"d0a",pos:"pp",det:"deterministic",mat:4,status:"active",hotl:true,trig:"event · 每次立卡或退卡后",eff:"2026-02 起",
  executor:"PO + 客户商务对口人",
  what:"维护 ATC 注册表与合同附件一致。边界：凡以 ATC 数量计价或验收的合同，附件须援引粒度准则。",
  how:"逐张列明名称、责任岗位、TEST 判据与 determinism；对客户计价范围按分类裁定执行（待裁）。",
  act:["注册表更新","合同附件比对","差异告知与签认"],
  test:"注册表与合同附件零差异；每次变更有客户签认记录。",
  bp:{ref:"BP-CAP-PO-003",ver:"v2.4",up:"2026-08-06"},runs:[["2026-08-09","human","success","1 h","tr-P3…6U"]],
  stat:{n30:6,ok:"100%",avg:"1 h",health:"g"},attr:{meeting:1,email:12,im:3,doc:8},dom:"dc-bld-01",
  src:[["商务邮箱（原生·邮件）","granted"]],secret:"未设定",tables:[]},
 po4:{code:"ATC-PO-004",name:"PO 主持周度建设对账",cls:"bld",run:"idle",
  desc:"每周对照建设计划核对各岗建设卡执行情况，输出偏差与决策待办。",
  dep:"d0a",pos:"pp",det:"deterministic",mat:3,status:"active",hotl:false,trig:"schedule · 每周五 16:00",eff:"2026-02 起",
  executor:"PO + 各建设岗",
  what:"周度核对建设进度与计划偏差。",how:"以各建设卡 TaskRun 证据为准，不以口头汇报为准。",
  act:["取各卡运行证据","偏差核对","待办分派"],test:"周报有证据引用；偏差项有责任人与期限。",
  bp:null,runs:[["2026-08-08","human","success","1 h","tr-P4…3V"]],
  stat:{n30:4,ok:"100%",avg:"1 h",health:"g"},attr:{meeting:4,email:3,im:6,doc:4},dom:"dc-bld-01",
  src:[["周会（原生·会议）","granted"]],secret:"未设定",tables:[]},
 po5:{code:"ATC-PO-005",name:"PO 组织知识隔离验收",cls:"bld",run:"off",
  desc:"组织验收 A：切断母版库，以真实历史出题，检验记忆自洽。编造一票否决。",
  dep:"d0a",pos:"pp",det:"deterministic",mat:1,status:"in_review",hotl:true,trig:"manual · M4 里程碑",eff:"未生效",
  executor:"PO + 客户评审组",
  what:"按题库组织知识隔离验收并出具结论。",how:"题目照承载项目真实历史出；评分与否决规则按验收条款执行。",
  act:["题库终审","验收执行","评分与结论"],test:"全卷评分留档；任一编造整卷不通过。",
  bp:{ref:"BP-CAP-PO-005",ver:"v1.0",up:"2026-08-02"},runs:[],
  stat:{n30:0,ok:"—",avg:"—",health:"a"},attr:{meeting:1,email:1,im:0,doc:6},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},

 /* ---- 数据运营岗 ---- */
 da1:{code:"ATC-DAT-001",name:"数据管理员建立数据胶囊域",cls:"bld",run:"idle",
  desc:"按中枢作用域建立数据胶囊域：每个中枢只承载其域内数据与连接，不建统一大库。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:4,status:"active",hotl:false,trig:"manual · 每域建设时",eff:"2026-02 起",
  executor:"数据管理员（我方）+ 客户 IT 对口人",
  what:"为目标中枢建立独立数据胶囊域，登记域标识与承载范围。边界：一域一实例，不跨域共库（分域裁定）。",
  how:"域按中枢作用域切分；同租户各域可同实现但实例独立；域标识落 hub 登记。",
  act:["域范围确认","实例建立","域标识登记","隔离性验证"],
  test:"域实例独立可查；跨域访问被拒（隔离性抽测）；域标识与中枢登记一致。",
  bp:{ref:"BP-CAP-DAT-001",ver:"v3.1",up:"2026-07-25"},runs:[["2026-03-02","hybrid","success","2 d","tr-D1…4W"]],
  stat:{n30:1,ok:"100%",avg:"2 d",health:"g"},attr:{meeting:3,email:5,im:4,doc:10},dom:"dc-bld-01",
  src:[["IT 对接会（原生·会议）","granted"]],secret:"HOW 段 protection_level = masked",tables:[]},
 da2:{code:"ATC-DAT-002",name:"数据管理员建立数据链接",cls:"bld",run:"run",
  desc:"建立到客户业务系统的数据连接，供开卡与执行取数。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:3,status:"active",hotl:false,trig:"event · 域建立后",eff:"2026-03 起",
  executor:"数据管理员（我方）+ 客户 IT 对口人",
  what:"为已授权的业务系统建立数据连接并验证取数。",how:"连接凭据不落明文；只读优先；写回须逐表授权。",
  act:["连接申请","凭据配置","取数验证","连接登记"],
  test:"连接清单与授权一致；取数抽查与源系统零偏差。",
  bp:{ref:"BP-CAP-DAT-002",ver:"v2.2",up:"2026-08-03"},runs:[["2026-08-10","hybrid","success","3 h","tr-D2…7X"]],
  stat:{n30:5,ok:"100%",avg:"3 h",health:"g"},attr:{meeting:2,email:6,im:9,doc:7},dom:"dc-bld-01",
  src:[["IT 工单（原生·文档）","granted"]],secret:"未设定",tables:[]},
 da3:{code:"ATC-DAT-003",name:"数据管理员登记接入源与授权",cls:"bld",run:"idle",
  desc:"盘点目标域全部数据源、责任人与授权状态，完成接入源登记。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:4,status:"active",hotl:false,trig:"manual · 每域建设时",eff:"2026-02 起",
  executor:"数据管理员（我方）+ 客户业务同事",
  what:"逐源登记责任人与授权状态。",how:"未登记的源不得接入；授权非 granted 不得写入；先原生后桥接。",
  act:["源清单访谈","逐源登记","授权待办跟踪"],test:"域内四类载体全覆盖；每源有责任人与授权状态。",
  bp:{ref:"BP-CAP-DAT-003",ver:"v3.2",up:"2026-07-15"},runs:[["2026-02-20","hybrid","success","3 d","tr-D3…2N"]],
  stat:{n30:0,ok:"100%",avg:"3 d",health:"g"},attr:{meeting:4,email:6,im:3,doc:8},dom:"dc-bld-01",
  src:[["调研访谈（原生·会议）","granted"]],secret:"HOW 段 protection_level = remote_only",tables:[]},
 da4:{code:"ATC-DAT-004",name:"数据管理员构建本质表",cls:"bld",run:"run",
  desc:"把分散在纸质与个人文件中的业务标准整理为本质表并配置索引（示例：成分标准三表）。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:3,status:"active",hotl:false,trig:"manual · 按域推进",eff:"2026-03 起",
  executor:"数据管理员（我方）+ 客户业务同事",
  what:"将业务标准整理为本质表，建立业务索引键（示例：钢种＋执行标准）。",
  how:"以现行有效标准为准；历史版本留档不覆盖；索引键唯一。",
  act:["标准收集","表结构化","索引配置","抽查验证"],
  test:"索引键唯一；抽查 30 条与原始标准零偏差；开卡一键填充可用。",
  bp:{ref:"BP-CAP-DAT-004",ver:"v2.1",up:"2026-07-20"},runs:[["2026-08-09","hybrid","success","1 d","tr-D4…3P"]],
  stat:{n30:2,ok:"100%",avg:"1 d",health:"g"},attr:{meeting:3,email:2,im:5,doc:21},dom:"dc-bld-01",
  src:[["标准文档目录（原生·文档）","granted"]],secret:"HOW 段 protection_level = masked",tables:["c007","c008","c009"]},
 da5:{code:"ATC-DAT-005",name:"数据管理员处理回溯注入建议",cls:"bld",run:"idle",
  desc:"新卡 certified 后触发的历史记录归属建议，逐条确认或驳回。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:2,status:"active",hotl:false,trig:"event · 新卡 certified 后",eff:"2026-04 起",
  executor:"数据管理员（我方）+ 岗位负责人",
  what:"处理回溯扫描产生的归属建议。",how:"确认以新版本归属表达，旧版保留；驳回须写理由。",
  act:["建议清单核对","逐条确认或驳回","归属版本落库"],test:"建议零积压超期；每条处置有理由。",
  bp:null,runs:[["2026-08-07","human","success","40 min","tr-D5…5Y"]],
  stat:{n30:3,ok:"100%",avg:"40 min",health:"g"},attr:{meeting:0,email:1,im:4,doc:3},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 da6:{code:"ATC-DAT-006",name:"数据管理员抽查数据质量与去重",cls:"bld",run:"idle",
  desc:"周期抽查记录去重与字段完整性，防止脏数据进入运营。",
  dep:"d0b",pos:"pd",det:"deterministic",mat:2,status:"active",hotl:false,trig:"schedule · 每周三",eff:"2026-04 起",
  executor:"数据管理员（我方）",
  what:"抽查记录去重命中与必填字段完整性。",how:"以内容散列去重约束为准；缺陷登记不静默修复。",
  act:["抽样","比对","缺陷登记"],test:"抽样报告留档；重复记录零漏检（样本内）。",
  bp:null,runs:[["2026-08-06","hub","success","15 min","tr-D6…8Z"]],
  stat:{n30:4,ok:"100%",avg:"15 min",health:"g"},attr:{meeting:0,email:0,im:2,doc:5},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},

 /* ---- 系统建设岗 ---- */
 sy1:{code:"ATC-SYS-001",name:"系统管理员部署服务器运行环境",cls:"bld",run:"idle",
  desc:"部署中枢运行环境：容器编排、端口与既有系统隔离、进程托管。",
  dep:"d0b",pos:"ps",det:"deterministic",mat:3,status:"active",hotl:false,trig:"manual · 环境建设时",eff:"2026-02 起",
  executor:"系统管理员（我方）+ 客户 IT",
  what:"在目标服务器部署中枢运行环境，与既有生产系统物理隔离。",
  how:"先盘点占用端口再分配；配置不落入代码仓库；部署于客户私有网络不暴露公网。",
  act:["端口与资源盘点","容器编排部署","隔离性验证","部署记录归档"],
  test:"服务健康检查通过；既有系统零影响；部署报告归档。",
  bp:{ref:"BP-CAP-SYS-001",ver:"v2.0",up:"2026-08-10"},runs:[["2026-08-11","hybrid","success","2 h","tr-S1…1A"]],
  stat:{n30:2,ok:"100%",avg:"2 h",health:"g"},attr:{meeting:1,email:2,im:5,doc:6},dom:"dc-bld-01",
  src:[["IT 工单（原生·文档）","granted"]],secret:"未设定",tables:[]},
 sy2:{code:"ATC-SYS-002",name:"系统管理员申请与管理大模型账号",cls:"bld",run:"idle",
  desc:"标准动作：申请外部大模型账号、配置配额与密钥引用、登记用量口径。",
  dep:"d0b",pos:"ps",det:"deterministic",mat:3,status:"active",hotl:true,trig:"manual · 环境建设时",eff:"2026-02 起",
  executor:"系统管理员（我方）+ 客户 IT / 商务",
  what:"完成外部模型账号申请、配额设定与密钥引用配置。边界：密钥只存引用，不落明文。",
  how:"账号归属与付费主体按合同约定；配额告警阈值先于上线设定。",
  act:["账号申请","密钥引用配置","配额与告警设定","登记归档"],
  test:"调用连通性验证通过；密钥明文零落盘；配额告警可触发。",
  bp:{ref:"BP-CAP-SYS-002",ver:"v1.4",up:"2026-07-28"},runs:[["2026-03-01","human","success","半天","tr-S2…2B"]],
  stat:{n30:1,ok:"100%",avg:"半天",health:"g"},attr:{meeting:1,email:6,im:2,doc:4},dom:"dc-bld-01",
  src:[["IT 工单（原生·文档）","granted"]],secret:"未设定",tables:[]},
 sy3:{code:"ATC-SYS-003",name:"系统管理员部署本地模型并验证降级",cls:"bld",run:"await",
  desc:"本地模型与外部模型双轨部署，外部不可达自动降级、不停机。",
  dep:"d0b",pos:"ps",det:"deterministic",mat:2,status:"active",hotl:true,trig:"manual · 环境建设时",eff:"2026-05 起",
  executor:"系统管理员（我方）",
  what:"部署本地模型，配置双轨切换，验证降级与恢复补齐。",
  how:"外部不可达自动切本地，不报错退出；恢复后补齐同步不产生重复记录；界面显示模型来源与降级状态。",
  act:["本地模型部署","双轨切换配置","断网降级演练","恢复补齐验证"],
  test:"断外网后感知不中断、记录不丢失；恢复后零重复记录；界面状态正确。",
  bp:{ref:"BP-CAP-SYS-003",ver:"v1.1",up:"2026-08-09"},runs:[["2026-08-10","hybrid","awaiting_approval","—","tr-S3…3C"]],
  stat:{n30:1,ok:"—",avg:"—",health:"a"},attr:{meeting:2,email:1,im:3,doc:8},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 sy4:{code:"ATC-SYS-004",name:"系统管理员配置权限与可见性",cls:"bld",run:"idle",
  desc:"跨级可见性规则落到权限与部署实现，非文档约定。",
  dep:"d0b",pos:"ps",det:"deterministic",mat:2,status:"active",hotl:true,trig:"manual · 每域上线前",eff:"2026-04 起",
  executor:"系统管理员（我方）+ 客户 IT",
  what:"按可见性规则配置各级权限，可见性由部署边界保证。",
  how:"部署边界优先于应用逻辑约束；配置变更留痕。",
  act:["权限矩阵配置","越权访问抽测","配置归档"],test:"越权访问抽测全部被拒；配置版本留档。",
  bp:null,runs:[["2026-07-30","human","success","2 h","tr-S4…4D"]],
  stat:{n30:2,ok:"100%",avg:"2 h",health:"g"},attr:{meeting:1,email:2,im:2,doc:5},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]},
 sy5:{code:"ATC-SYS-005",name:"系统管理员执行离线连续运行演练",cls:"bld",run:"off",
  desc:"离线运行验收预演：切断外网与外部模型，目标连续运行 72 小时。",
  dep:"d0b",pos:"ps",det:"deterministic",mat:1,status:"in_review",hotl:true,trig:"manual · M5 前",eff:"未生效",
  executor:"系统管理员（我方）+ 客户 IT",
  what:"组织 72 小时离线连续运行演练并出具报告。",how:"演练期间感知、记录、既有卡执行三项均不得中断。",
  act:["演练方案评审","断网执行","恢复补齐核对","报告归档"],
  test:"连续离线不低于 72 小时；恢复后零重复记录；报告归档。",
  bp:{ref:"BP-CAP-SYS-005",ver:"v1.0",up:"2026-08-11"},runs:[],
  stat:{n30:0,ok:"—",avg:"—",health:"a"},attr:{meeting:1,email:0,im:1,doc:3},dom:"dc-bld-01",
  src:[],secret:"未设定",tables:[]}
} as const;

export const CHAIN = ["draft","in_review","certified","active","suspended","retired"] as const;

export const RUNLAMP = {run:"run",idle:"idle",await:"await",fail:"fail",off:"off"} as const;

export const RUNTXT = {run:"执行中",idle:"空闲",await:"待审批",fail:"异常",off:"未生效"} as const;

export const POSROOMS = {
 pE1:2,pE2:1,pD1:1,pD3:1,pD6:1,pD0a:1,pD0b:1,
 pf:5,pp:5,pd:6,ps:5,/* 体系建设 21 */
 p1:9,p2:8,/* 热加工 17 */
 p3:22,/* 冷加工 22 */
 p4:8,p5:6,/* 理化 14 */
 p6:6,/* 检验 6 */
 p7:18,/* 库存 18 */
 p8:3,p9:2,/* 销售 5 */
 p10:5,/* 财务 5 */
 p11:8                         /* 领导层 8 */
} as const;

export const RM2CLS = {run:"run",idle:"ok",await:"await",fail:"fail",off:"off"} as const;

export const STUBS = {
 track:{t:"任务跟踪",d:"以固定检查点批量核查任务提交状态（V1 无实时触达）。",
  blocks:["今日检查点结果表：ATC × 检查点 × 提交状态（含 not_submitted）","近 30 日未提交趋势与责任岗位分布","失败任务清单与 TEST 判据不符项","逐条可跳转对应 TaskRun 证据（只读）"]},
 approve:{t:"审批中心",d:"hotl_gate 待审队列。本页为三类允许动作中的「做审批」。",
  blocks:["待审队列：提交时间 · ATC · 提交方 · 证据引用","审批动作：通过 / 退回（留痕，：通过后置 success）","历史审批记录与平均时效","超时未审提醒"]},
 audit:{t:"日常审计",d:"四类日常审计每业务日各一条，无发现亦落记录。",
  blocks:["今日四类审计状态卡","近 30 日发现项分布与整改状态","审计记录明细（只读，可溯源）","与执行审计（单次）的分层说明"]},
 commit:{t:"承诺与结算",d:"每日承诺清单与实际交付逐项对照，计算一致率（daily_commitment）。",
  blocks:["今日承诺清单与完成对照","100 日一致率移动均值与标准差曲线","偏差项归因（按部门 / 岗位）","承诺生成方式说明（待决）"]},
 data:{t:"数据与接入",d:"数据胶囊域与接入源的登记、授权与健康状态。",
  blocks:["胶囊域清单：域标识 · 承载中枢 · 隔离状态","接入源清单：载体 · 通道 · consent 状态 · 桥接退出计划","四类载体记录量走势","本质表清单与索引健康"]},
 build:{t:"建设进度",d:"四个建设岗 21 张标准动作卡的推进视图，对照里程碑基线。",
  blocks:["里程碑基线与实际（M0–M6）","各建设岗建设卡状态板","验收准备度：知识隔离验收 · 离线运行验收","未决事项台账"]}
} as const;

export const STB = {draft:"gry",in_review:"amb",certified:"blu",active:"ok",suspended:"gry",retired:"gry"} as const;

export const SURN = ["刘","周","吴","郑","孙","钱","冯","蒋","沈","韩","杨","朱","秦","许"] as const;

export const ROLEB = {责任人:"ok",使用者:"blu",评价者:"pur"} as const;
